import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

import { Observable } from 'rxjs';

import { FilesListComponent } from '@camelot/files-basic';
import { Menu, ToggleNavigationComponent } from '@camelot/menu';
import { ErrorComponent, LoaderComponent } from '@camelot/ui';
import { CamBaseComponent, FileData, FileStructure, FileType } from '@camelot/utils';

import { Feature } from '../upload/files-upload.component';
import { FilesUploadComponent } from '../upload/files-upload.component';

@Component({
  selector: 'cam-files-display',
  templateUrl: './files-display.component.html',
  styleUrls: ['./files-display.component.scss'],
  imports: [
    CommonModule,
    FilesListComponent,
    FilesUploadComponent,
    ToggleNavigationComponent,
    LoaderComponent,
    ErrorComponent,
  ],
})
export class FilesDisplayComponent extends CamBaseComponent {
  files$ = input.required<Observable<FileData[]>>();
  menu = input.required<Menu>();
  canAddFile = input(true);
  tempFiles = input<FileData[]>([]);
  fileType = input.required<FileType>();

  fileSelected = output<FileData & { index: number }>();
  moreInformationSelected = output<FileData>();
  fileUploading = output<FileStructure[]>();

  get canSelectMultipleFiles(): boolean {
    switch (this.fileType()) {
      case 'Document':
        return false;
      case 'Image':
        return true;
      default:
        return false;
    }
  }

  get canDisplayTempsFiles(): boolean {
    return this.tempFiles()?.length > 0;
  }

  public getFeature(): Feature[] {
    switch (this.fileType()) {
      case 'Document':
        return ['upload-file'];
      case 'Image':
        return ['upload-pic'];
      default:
        return [];
    }
  }
}
